import React from 'react';

export const RedIlimitado2 = () => {
    return (
        <>
            <div className="txtRedes1">Disfruta tu servicio ilimitado de:</div>
            <div className='unefon1'></div>
            <div className="txtRedes2">Min, SMS y MB ilimitados desde Mex a Mex y EUA; en datos aplica baja de velocidad</div>
        </>
      )
}
